export class ProjectionContext {
  constructor(
    public area: HTMLDivElement,
    public canvas: HTMLCanvasElement,
  ) {}
}
